export default "__VITE_ASSET__SOTog7G2__"